export const PROCESS_TEMPLATES_MODALS = {
  create: 'create',
  delete: 'delete',
  change: 'change',
};

export const DEFAULT_PROCESS_TEMPLATES = {
  _id: '',
  name: '',
  createdBy: '',
  platformCompanyId: '',
  createdAt: 'string',
};


export const PROCESS_TASKS_MODALS = {
  delete: 'delete',
  create: 'create',
  edit: 'edit',
};
